module.exports = __webpack_public_path__ + "img/서브2_시야.78ebe6e7.svg";